import { POPUP_ACTIONS } from './types';
import store from '../../../helpers/store';
import Logger from '../../../../common/logger';
import * as MainActions from '../../main/actions';
import { LAYERS } from '../types';
import { DISPLAY } from '../../main/types';
import * as ConfigurationActions from '../../../helpers/configuration/actions';

export const getConfig = (defaultView) => {
    const state = store.getState();
    defaultView = defaultView.toUpperCase();
    return state.config.popup
        ? state.config.popup.findLast((p) => p.defaultView.toUpperCase() === defaultView)
        : null;
};

const getView = (view) => {
    return view ? view.toUpperCase().replace('POPUP', '') : null;
};

export const onInit = () => {
    const state = store.getState();
    store.dispatch({
        type: POPUP_ACTIONS.INIT,
        data: {
            currentView: state.popup.currentView,
            currentConfig: state.popup.currentConfig
        }
    });
};

export const onOpen = (config) => {
    const currentView = getView(config.defaultView);
    if (!currentView) {
        return;
    }

    let currentConfig;
    if (config[currentView.toLowerCase() + 'Options']) {
        currentConfig = config;
    } else {
        currentConfig = getConfig(config.defaultView);
    }

    if (currentConfig && currentConfig.debugGWE) {
        Logger.setDebugGWE(currentConfig.debugGWE);
    }

    store.dispatch({
        type: POPUP_ACTIONS.OPEN,
        data: {
            configId: config.id,
            currentConfig,
            currentView
        }
    });
};

export const onClose = ({ reason, removeConfig = true }) => {
    if (removeConfig) {
        const state = store.getState();
        ConfigurationActions.removePopupConfig(state.popup.configId);
    }

    MainActions.onClose({
        layer: LAYERS.POPUP,
        reason: reason
    });
    store.dispatch({
        type: POPUP_ACTIONS.CLOSE
    });
};

export const onPreloaderClose = () => {
    store.dispatch({
        type: POPUP_ACTIONS.SWITCH,
        data: {
            view: 'PRELOADER_CLOSING'
        }
    });
};

export const onParentResize = () => {
    MainActions.updateMainLayer({
        layer: LAYERS.POPUP,
        iFrameMode: DISPLAY.FULLSCREEN
    });
};
